import React, { useState, useEffect } from 'react';
import '../css/Experience.css';

const Experience = () => {
  const [overallEngineering, setYears1] = useState(0);
  const [activelyWorking, setYears2] = useState(0);

  useEffect(() => {
    const currentYear = new Date().getFullYear();
    const startYear = 2014;
    const elapsedYears = currentYear - startYear;
    setYears1(elapsedYears);
  }, []);

  useEffect(() => {
    const currentYear = new Date().getFullYear();
    const startYear = 2018;
    const elapsedYears = currentYear - startYear;
    setYears2(elapsedYears);
  }, []);


  const experiences = [
    {
      jobTitle: 'Full Stack Software Engineer',
      company: 'Accesso Tenchology Company PLC.',
      duration: 'Nov 2021 - Present',
      description: 'When guests wait less, they can enjoy more! Free your guests from physical queues and allow them to explore all your venue has to offer. Our patented suite of online virtual queuing solutions has helped over 19 million guests around the world avoid long lines and make the most of their day.',
    },
    {
      jobTitle: 'Full Stack Software Engineer',
      company: 'Whitespace Software Limited',
      duration: 'Dec 2018 - Oct 2021',
      description: 'In 2015, Whitespace focused on new distributed databases and agile data techniques, aiming to apply them to the insurance industry. Among other solutions, this effort led to the development of the Whitespace Platform, a modern and integrated trading system for the global (re)insurance markets.The company was excited about the future, from the rising interest in private capital at Lloyd’s to the digital market enabled by the Whitespace Platform, and everything in between.',
    },
    {
      jobTitle: 'Full Stack Virtual Reality Software Engineer (Intern)',
      company: 'Digitalcomoedia Srl',
      duration: 'Apr 2018 - Oct 2018',
      description: 'This company provided me with an incredible opportunity through their Virtual Reality internship program. During my time there, I had the chance to develop a Hand Gesture Recognition (HGR) system using the Leap Motion Controller and its SDK. I utilized Unity3D as the integrated development environment (IDE) to build the system. Additionally, my university thesis was based on this HGR system, exploring its capabilities and applications in virtual reality.',
    },
  ];

  return (
    <section className="experience">
      <header className="section-head">
        <span className="section-eyebrow">2018 &mdash; present</span>
        <h1 className="section-title">Experience</h1>
        <div className="section-meta">
          <span className="section-meta-item">{overallEngineering}+ years in software engineering</span>
          <span className="section-meta-item">{activelyWorking}+ years in Agile business</span>
          <span className="section-meta-item">Bachelor&rsquo;s degree 2:1</span>
        </div>
      </header>

      <div className="card-stack">
        {experiences.map((exp, index) => (
          <article key={index} className="card">
            <div className="card-head">
              <div>
                <h2 className="card-title">{exp.company}</h2>
                <p className="card-subtitle">{exp.jobTitle}</p>
              </div>
              <span className="card-tag">{exp.duration}</span>
            </div>
            <p className="card-body">{exp.description}</p>
          </article>
        ))}
      </div>
    </section>
  );
};

export default Experience;
